import type * as Types from '../../../schemas/shopify/admin.types';

export type PickPageCollectionNodeFragment = Pick<
  Types.Collection,
  'id' | 'handle' | 'title' | 'templateSuffix'
> & {
  image?: Types.Maybe<Pick<Types.Image, 'url'>>;
  resourcePublications: { nodes: Array<{ publication: { app: Pick<Types.App, 'handle'> } }> };
};

export const PickPageCollectionNodeFragmentDoc = `
    fragment PickPageCollectionNode on Collection {
  id
  handle
  title
  templateSuffix
  image {
    url
  }
  resourcePublications(first: 25, onlyPublished: true) {
    nodes {
      publication {
        app {
          handle
        }
      }
    }
  }
}
    `;
